import { render, staticRenderFns } from "./ReportLoader.vue?vue&type=template&id=513e0188&scoped=true&"
import script from "./ReportLoader.vue?vue&type=script&lang=js&"
export * from "./ReportLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513e0188",
  null
  
)

export default component.exports